export default __webpack_public_path__ + "static/media/header-background.769baf5e.png";